/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Grid, Paper, InputLabel, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS } from 'styles/theme';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import classNames from 'classnames';
import { showToast } from 'modules/layout/layout.actions';
import SurveyQuestionTriggerCard from './surveyQuestionTriggerCard.component';
import SurveyQuestionAnswerCard from './surveyQuestionAnswerCard.component';
import SurveyQuestionSetupCard from './surveyQuestionSetupCard.component';
import { updateSurveyQuestion, getSurveyQuestionById, getSurveyQuestions } from '../surveys.actions';
import { UPDATE_SURVEY_QUESTION_FAILURE } from '../surveys.types';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';

const styles = theme => ({
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  headerFixed: {
    zIndex: 4
  },
  estimateHeaderFixed: {
    paddingTop: '115px',
    zIndex: 2
  }
});

const SurveyQuestionDetails = props => {
  const { surveyQuestionDetails, staticTriggerFields, surveyStatuses, taggedItems, enumerations } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [newQuestionName, setNewQuestionName] = useState(surveyQuestionDetails ? surveyQuestionDetails.surveyQuestion.questionName : '');
  const [newQuestionStatus, setNewQuestionStatus] = useState(
    surveyQuestionDetails ? surveyQuestionDetails.surveyQuestion.statusId : ZERO_GUID
  );
  const [questionCategory, setQuestionCategory] = useState(
    surveyQuestionDetails ? surveyQuestionDetails.surveyQuestion.surveyCategoryId : ''
  );
  const [questionOrderWeight, setQuestionOrderWeight] = useState(
    surveyQuestionDetails ? surveyQuestionDetails.surveyQuestion.surveyPositionWeight : ''
  );

  const questionCategoryOptions =
    enumerations && enumerations.surveyQuestionCategories ? enumerations.surveyQuestionCategories.filter(s => s.isActive) : [];

  const handleUpdate = async () => {
    setIsLoading(true);

    let newVals = { ...surveyQuestionDetails.surveyQuestion };
    newVals.questionName = newQuestionName;
    newVals.statusId = newQuestionStatus;
    newVals.surveyCategoryId = questionCategory;
    newVals.surveyPositionWeight = questionOrderWeight;
    let resp = await props.updateSurveyQuestion(newVals);
    if (resp.type === UPDATE_SURVEY_QUESTION_FAILURE) {
      props.showToast('Failed to update survey question, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
    } else {
      await props.getSurveyQuestions();
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Box>
        <Paper square className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}>
          <Box
            sx={{
              padding: '10px',
              width: '100%',
              display: 'flex',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                flex: 1,
                minWidth: 0
              }}
            >
              <Box
                sx={{
                  minWidth: 150,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                  Question Id
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                  {surveyQuestionDetails.surveyQuestion.surveyQuestionId}
                </Typography>
              </Box>
              <TextField
                label={'Question Name'}
                value={newQuestionName}
                onChange={e => setNewQuestionName(e.target.value)}
                margin="dense"
                sx={{ minWidth: 260 }}
              />
              <FormControl margin="dense" sx={{ minWidth: 150 }}>
                <InputLabel>Category</InputLabel>
                <Select label={'Category'} value={questionCategory} onChange={e => setQuestionCategory(e.target.value)}>
                  {questionCategoryOptions.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label={'Question Order'}
                value={questionOrderWeight}
                onChange={e => setQuestionOrderWeight(e.target.value)}
                margin="dense"
                sx={{ width: 160 }}
              />
              <FormControl margin="dense" sx={{ minWidth: 150 }}>
                <InputLabel>Status</InputLabel>
                <Select label={'Status'} value={newQuestionStatus} onChange={e => setNewQuestionStatus(e.target.value)}>
                  {surveyStatuses.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ paddingLeft: '20px' }}>
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', marginRight: '20px', marginTop: '8px' }}
                  onClick={() => handleUpdate()}
                  disabled={isLoading}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
        <Box sx={{ padding: '16px', paddingTop: '120px' }}>
          <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
            <Grid item xs={12} xl={8} rowSpacing={2}>
              <SurveyQuestionTriggerCard
                surveyQuestionTriggers={surveyQuestionDetails.surveyTriggers}
                surveyQuestionId={surveyQuestionDetails.surveyQuestion.surveyQuestionId}
                isReadOnly={false}
                staticTriggerFields={staticTriggerFields}
              />
              <Box sx={{ paddingTop: '16px' }}>
                <SurveyQuestionAnswerCard surveyQuestionDetails={surveyQuestionDetails.surveyQuestion} isReadOnly={false} />
              </Box>
              <Box sx={{ paddingTop: '16px' }}>
                <SurveyQuestionSetupCard
                  surveyQuestionVariations={surveyQuestionDetails.surveyQuestionVariations}
                  surveyQuestionId={surveyQuestionDetails.surveyQuestion.surveyQuestionId}
                  taggedItems={taggedItems}
                  isReadOnly={false}
                />
              </Box>
            </Grid>
            <Grid item xs={12} xl={4} rowSpacing={2}>
              <Box></Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

const mapStateToProps = state => {
  const { surveyStatuses } = state.enumerations.allEnums;
  return {
    surveyStatuses: surveyStatuses
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { updateSurveyQuestion, getSurveyQuestionById, showToast, getSurveyQuestions })
)(SurveyQuestionDetails);
